export default {"src":"/_next/static/media/link_brand.b4b134c1.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};